import './js/headerMenu.js';
import './js/spinner.js';
import './sass/main.scss';
import './js/infiniteScroll.js';
import './js/fetchAPI.js';
import './js/localStorageAPI.js';
import './js/buttonScrollUp.js';
import './js/team-modal.js';
import './js/trailer.js';
import './js/modalClose.js';
import './js/onCardClick.js';
import './js/change-theme.js';
import './js/renderFromLocalStorage.js';
import './js/eventHandlerSearch.js';
import './js/filterByGenre.js'
import './js/switch-lang.js';